import { EonUiPreloaderCircle } from "@eon-ui/eon-ui-components-react";

const OnboardingPortalLoader = () => (
    <div className="onboarding-portal--loader">
        <EonUiPreloaderCircle />
    </div>
);

export default OnboardingPortalLoader;
